module.exports = __webpack_public_path__ + "img/cashback.47d31aa6.svg";